import {FinancialEntryEntity} from "../../../../../domain/entity/financial-entry.entity";
import {ListFinancialEntryItem} from "../list.financial-entry-item";

export function ItemsEntry(props: { entry: FinancialEntryEntity }) {
  return (
    <>
      <ListFinancialEntryItem data={props.entry.items} />
    </>
  )
}